import { render, staticRenderFns } from "./tjlxBarChart.vue?vue&type=template&id=00b14f17&scoped=true"
import script from "./tjlxBarChart.vue?vue&type=script&lang=js"
export * from "./tjlxBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b14f17",
  null
  
)

export default component.exports